import { CalendarCheck, Video, Rocket } from "lucide-react";
import { howItWorksContent } from "@/content/homepage";

export const HowItWorks = () => {
  const iconMap = [CalendarCheck, Video, Rocket];
  const steps = howItWorksContent.steps.map((step, idx) => ({
    icon: iconMap[idx],
    ...step
  }));
  return <section className="py-24 md:py-32 bg-muted/20">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 text-foreground md:text-5xl">{howItWorksContent.title}</h2>
          <p className="text-xl text-muted-foreground">
            {howItWorksContent.subtitle}
          </p>
        </div>

        <div className="grid gap-12 md:grid-cols-3 mx-auto max-w-6xl">
          {steps.map((step, index) => <div key={index} className="relative text-center">
              <div className="mb-6 mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <step.icon className="h-10 w-10" />
              </div>
              
              <div className="mb-3 text-sm font-bold text-secondary tracking-wider uppercase">
                {howItWorksContent.stepLabel} {index + 1}
              </div>
              
              <h3 className="mb-4 text-2xl font-bold text-foreground">
                {step.title}
              </h3>
              
              <p className="text-lg text-muted-foreground leading-relaxed">
                {step.description}
              </p>
              
              {index < steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-secondary/40 to-transparent" />}
            </div>)}
        </div>
      </div>
    </section>;
};